import type {State} from '../reducers/types'

import {useAppSelector} from 'src/hooks/react-redux'

export default <T>(selector: (arg0: State) => T): T => useAppSelector(selector, () => true)
